import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CadastroCompletoComponent } from './cadastro-completo.component';

const routes: Routes = [{ path: '', component: CadastroCompletoComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CadastroCompletoRoutingModule { }
